module.exports = __webpack_public_path__ + "img/1457525535.0248167b.jpg";